module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 0 0",
      "height": "100%"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-cell-group', [_c('van-field', {
    attrs: {
      "name": "radio",
      "label": "身份",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.lunwen_type),
            callback: function($$v) {
              _vm.$set(_vm.formData, "lunwen_type", $$v)
            },
            expression: "formData.lunwen_type"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "本科生"
          }
        }, [_vm._v("本科生")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "研究生"
          }
        }, [_vm._v("研究生")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "论文题目",
      "rules": [{
        required: true,
        message: '不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入论文题目"
    },
    model: {
      value: (_vm.formData.lunwen_title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "lunwen_title", $$v)
      },
      expression: "formData.lunwen_title"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "上传大摘要"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('FileUploader', {
    attrs: {
      "uploadText": "上传文件",
      "fileList": _vm.formData.lunwen_dazhaiyao,
      "limit": 1,
      "accept": ".docx",
      "name": 'lunwen_dazhaiyao'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("要求：格式docx、字数不少于1000字")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "上传论文文件"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('FileUploader', {
    attrs: {
      "uploadText": "上传文件",
      "fileList": _vm.formData.lunwen_content,
      "limit": 1,
      "accept": ".docx",
      "name": 'lunwen_content'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("要求：格式docx、字数不少于10000字")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "100px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54fc5dd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/huiyi/HuiyiApplyFormStep10.vue
// module id = 2381
// module chunks = 0